import orderConfig from "emun.order/order.config";
import retailerConfig from "emun.retailer/retailer.config";
import templateUrl from "emun.salesrep/b2b-dashboard.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import basicController from "servicestack/basic.controller.properties";

class B2BDashboardController {
  constructor(createAutoQuery, $session, $window, $state, utils) {
    basicController(this);
    let $ctrl = this;
    $ctrl.utils = utils;
    $ctrl.orderConfig = orderConfig;
    $ctrl.retailerConfig = retailerConfig;
    $ctrl.productImage = $ctrl.$appConfig.productImage.bind($ctrl.$appConfig);
    $ctrl.visitorsToday = 0;
    $ctrl.visitorsYesterday = 0;
    $ctrl.visitorsWeek = 0;
    $ctrl.visitorsMonth = 0;
    $ctrl.visitorsLastMonth = 0;
    $ctrl.visitorsYear = 0;
    $ctrl.visitorsTodayNew = 0;
    $ctrl.visitorsYesterdayNew = 0;
    $ctrl.visitorsWeekNew = 0;
    $ctrl.visitorsMonthNew = 0;
    $ctrl.visitorsLastMonthNew = 0;
    $ctrl.visitorsYearNew = 0;
    $ctrl.today = moment().format("MM/DD/YYYY");
    $ctrl.userSessions = new AutoQuery({
      url: "QueryB2BDailyLogins.json",
      autoLoad: true,
      criteria: {
        dateRange: "Last7",
      },
      pageSize: 10,
      scrollTop: false,
      disableQueryString: true,
    });

    $ctrl.quickReportsQuery = new AutoQuery({
      url: "QueryQuickReports.json?",
      orderBy: "Type,Name",
      sortOptions: {
        "Type,Name": "Name: A to Z",
        "-Type,Name": "Name: Z to A",
      },
      tagCriteria: {
        Dashboards: "B2B",
      },
      autoLoad: true,
      onLoaded(args) {
        $ctrl.quickReports = args.results;
      },
      pageSize: 1000,
    });

    $ctrl.uniqueVisitorsToday = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=Today&CountDistinct=FullName&GroupBy=FullName",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsToday += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });
    $ctrl.uniqueVisitorsYesterday = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=Yesterday&CountDistinct=FullName&GroupBy=FullName",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsYesterday += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });
    $ctrl.uniqueVisitorsWeek = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=Week&CountDistinct=FullName&GroupBy=FullName",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsWeek += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });
    $ctrl.uniqueVisitorsMonth = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=Month&CountDistinct=FullName&GroupBy=FullName",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsMonth += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });
    $ctrl.uniqueVisitorsLastMonth = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=LastMonth&CountDistinct=FullName&GroupBy=FullName",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsLastMonth += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });
    $ctrl.uniqueVisitorsYTD = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=YTD&CountDistinct=FullName&GroupBy=FullName",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsYear += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });

    //new logins
    $ctrl.uniqueVisitorsTodayNew = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=Today&CountDistinct=FullName&GroupBy=FullName&NewLogins=true",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsTodayNew += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });
    $ctrl.uniqueVisitorsYesterdayNew = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=Yesterday&CountDistinct=FullName&GroupBy=FullName&NewLogins=true",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsYesterdayNew += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });
    $ctrl.uniqueVisitorsWeekNew = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=Week&CountDistinct=FullName&GroupBy=FullName&NewLogins=true",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsWeekNew += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });
    $ctrl.uniqueVisitorsMonthNew = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=Month&CountDistinct=FullName&GroupBy=FullName&NewLogins=true",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsMonthNew += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });
    $ctrl.uniqueVisitorsLastMonthNew = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=LastMonth&CountDistinct=FullName&GroupBy=FullName&NewLogins=true",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsLastMonthNew += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });
    $ctrl.uniqueVisitorsYTDNew = new AutoQuery({
      url: "QueryB2BDailyLogins.json?dateRange=YTD&CountDistinct=FullName&GroupBy=FullName&NewLogins=true",
      autoLoad: true,
      onLoaded: function (args) {
        args.results.forEach(function (obj) {
          $ctrl.visitorsYearNew += obj.countDistinctFullName;
        });
      },
      pageSize: 50000,
    });

    $ctrl.mostViewedProductsOrderByField = "sumNumViews";
    $ctrl.mostViewedProductsReverseSort = true;
    $ctrl.mostViewedProducts = new AutoQuery({
      url: "QueryMostViewedProducts.json?Fields=ProductId,Description&Sum=NumViews,TotalSold&GroupBy=ProductId,Description",
      criteria: {
        dateRange: "Last7",
        startDate: $ctrl.today,
        endDate: $ctrl.today,
      },
      //orderBy: "-NumViews",
      autoLoad: true,
      disableQueryString: true,
      pageSize: 10000,
    });

    $ctrl.mostSoldProductsOrderByField = "sumQtyPurchased";
    $ctrl.mostSoldProductsReverseSort = true;
    $ctrl.mostSoldProducts = new AutoQuery({
      url: "QueryCartItemsJoin.json?Sum=QtyPurchased,ExtendedTotal&groupBy=productId,description&orderBy=productId&GeneratedFrom=B2B&StatusIn=Open,Completed&QtyPurchasedGreaterThan=0",
      criteria: {
        dateRange: "Last7",
        clientDateTime: moment().format("MM/DD/YYYY H:m:s Z"),
        startDate: $ctrl.today,
        endDate: $ctrl.today,
      },
      autoLoad: true,
      disableQueryString: true,
      pageSize: 10000,
    });

    $ctrl.openOrders = new AutoQuery({
      url: "QueryCartsJoin.json?StatusNotIn=Deleted&GeneratedFrom=B2B",
      orderBy: "-OrderedOn",
      autoLoad: true,
      criteria: {
        dateRange: "Last7",
        clientDateTime: moment().format("MM/DD/YYYY H:m:s Z"),
        startDate: $ctrl.today,
        endDate: $ctrl.today,
      },
      pageSize: 10,
      scrollTop: false,
      disableQueryString: true,
      fields: orderConfig.fields || undefined,
    });

    this.dailySales = {
      total: 0,
      count: 0,
    };
    this.yesterdaySales = {
      total: 0,
      count: 0,
    };
    this.weekSales = {
      total: 0,
      count: 0,
    };
    this.ytdSales = {
      total: 0,
      count: 0,
    };
    this.mtdSales = {
      total: 0,
      count: 0,
    };
    this.lastmonthSales = {
      total: 0,
      count: 0,
    };
    this.lyweekSales = {
      total: 0,
      count: 0,
    };
    this.lytdSales = {
      total: 0,
      count: 0,
    };
    this.lymtdSales = {
      total: 0,
      count: 0,
    };
    this.newPending = {
      total: 0,
      count: 0,
    };
    $ctrl.dailySalesQuery = createAutoQuery({
      url: "QuerySalesYOYTotals.json?Sum=TotalSalesToday,TotalSalesCountToday,TotalSalesYesterday,TotalSalesCountYesterday,TotalSalesWeekToDate,TotalSalesCountWeekToDate,TotalSalesWeekToDateLastYear,TotalSalesCountWeekToDateLastYear,TotalSalesYearToDate,TotalSalesCountYearToDate,TotalSalesYearToDateLastYear,TotalSalesCountYearToDateLastYear,TotalSalesMonthToDate,TotalSalesCountMonthToDate,TotalSalesLastMonthThisYear,TotalSalesCountLastMonthThisYear,TotalSalesMonthToDateLastYear,TotalSalesCountMonthToDateLastYear&GeneratedFrom=B2B&GroupBy=GeneratedFROM",
      autoLoad: true,
      pageSize: 50000,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            //$ctrl.dailySales.total += res.sumTotalSalesToday;
            //$ctrl.dailySales.count += res.sumTotalSalesCountToday;
            $ctrl.yesterdaySales.total += res.sumTotalSalesYesterday;
            $ctrl.yesterdaySales.count += res.sumTotalSalesCountYesterday;
            $ctrl.weekSales.total += res.sumTotalSalesWeekToDate;
            $ctrl.weekSales.count += res.sumTotalSalesCountWeekToDate;
            $ctrl.ytdSales.total += res.sumTotalSalesYearToDate;
            $ctrl.ytdSales.count += res.sumTotalSalesCountYearToDate;
            $ctrl.mtdSales.total += res.sumTotalSalesMonthToDate;
            $ctrl.mtdSales.count += res.sumTotalSalesCountMonthToDate;
            $ctrl.lastmonthSales.total += res.sumTotalSalesLastMonthThisYear;
            $ctrl.lastmonthSales.count +=
              res.sumTotalSalesCountLastMonthThisYear;
            //LY
            $ctrl.lyweekSales.total += res.sumTotalSalesWeekToDateLastYear;
            $ctrl.lyweekSales.count += res.sumTotalSalesCountWeekToDateLastYear;
            $ctrl.lytdSales.total += res.sumTotalSalesYearToDateLastYear;
            $ctrl.lytdSales.count += res.sumTotalSalesCountYearToDateLastYear;
            $ctrl.lymtdSales.total += res.sumTotalSalesMonthToDateLastYear;
            $ctrl.lymtdSales.count += res.sumTotalSalesCountMonthToDateLastYear;
          });
        }
      },
    });
    //$ctrl.openOrders = new AutoQuery({
    //	url:
    //		"QueryCartsJoin.json?StatusIn=Open,Completed&GeneratedFrom=B2B",
    //	orderBy: "-OrderedOn",
    //	autoLoad: true,
    //	criteria: {
    //		OrderedOn: moment().format("l"),
    //		clientDateTime: moment().format("MM/DD/YYYY H:m:s Z")
    //		//dateRange: 'Today'
    //	},
    //	pageSize: 10,
    //	scrollTop: false,
    //	disableQueryString: true,
    //	onLoaded: function (args) {
    //		//if (args.total > 0) {
    //		//  args.results.forEach(function (res) {
    //		//    $ctrl.dailySales.total += res.grandTotal;
    //		//  });
    //		//  $ctrl.dailySales.count = args.total;
    //		//}
    //	}
    //});

    $ctrl.todayTotal = new AutoQuery({
      url: "QueryCartsJoin.json?StatusIn=Open,Completed&GeneratedFrom=B2B&Sum=GrandTotal&GroupBy=OrderedOn",
      autoLoad: true,
      criteria: {
        OrderedOn: moment().format("l"),
        clientDateTime: moment().format("MM/DD/YYYY H:m:s Z"),
        //dateRange: 'Today'
      },
      scrollTop: false,
      disableQueryString: true,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            $ctrl.dailySales.total += res.sumGrandTotal;
          });
        }
      },
    });

    $ctrl.todayTotalCount = new AutoQuery({
      url: "QueryCartsJoin.json?StatusIn=Open,Completed&GeneratedFrom=B2B&Count=Id&GroupBy=OrderedOn",
      autoLoad: true,
      criteria: {
        OrderedOn: moment().format("l"),
        clientDateTime: moment().format("MM/DD/YYYY H:m:s Z"),
        //dateRange: 'Today'
      },
      scrollTop: false,
      disableQueryString: true,
      onLoaded: function (args) {
        if (args.total > 0 && args.results) {
          $ctrl.dailySales.count = args.results[0].Total;
        }
      },
    });

    $ctrl.pendingRequests = new AutoQuery({
      url: "QueryRetailersJoin.json?Status=Inactive&CustomerTypeNotIn=Customer,Prospect&GroupBy=CustomerType",
      autoLoad: true,
      criteria: {
        CustomerTypeIn: $ctrl.retailerConfig.pendingRequestsTypes,
      },
      scrollTop: false,
      onLoaded: function (args) {
        if (args.total > 0) {
          args.results.forEach(function (res) {
            if (res) {
              $ctrl.newPending.total += res.Total;
            }
          });
        }
      },
    });

    this.$session = $session;
  }
  downloadViewedProducts() {
    let $ctrl = this;
    var itemsFormatted = [];

    var headers = {
      Product: "Product",
      Title: "Title",
      LastViewed: "LastViewed",
      Views: "Views",
    };

    // format the data
    $ctrl.mostViewedProducts.results.forEach((item) => {
      itemsFormatted.push({
        Product: item.productId.replace(/,/g, ""), // remove commas to avoid errors,
        Title: item.description.replace(/,/g, ""),
        //LastViewed: item.lastViewed,
        Views: item.sumNumViews,
      });
    });

    var fileTitle = "top-browsed-products";
    $ctrl.utils.exportCSVFile(headers, itemsFormatted, fileTitle);
  }
  downloadSoldProducts() {
    let $ctrl = this;
    var itemsFormatted = [];

    var headers = {
      Product: "Product",
      Title: "Title",
      Sold: "Sold",
      Total: "Total",
    };

    // format the data
    $ctrl.mostSoldProducts.results.forEach((item) => {
      itemsFormatted.push({
        Product: item.productId.replace(/,/g, ""), // remove commas to avoid errors,
        Title: item.description.replace(/,/g, ""),
        Sold: item.sumQtyPurchased,
        Total: item.sumExtendedTotal,
      });
    });

    var fileTitle = "top-sold-products";
    $ctrl.utils.exportCSVFile(headers, itemsFormatted, fileTitle);
  }
  downloadOpenOrders() {
    let $ctrl = this;
    var url = $ctrl.$appConfig.resolveServiceUrl(
      "" + $ctrl.openOrder.url.replace(".json", ".csv")
    );
    return (location.href = url);
  }
  downloadUserSessions() {
    let $ctrl = this;
    var url = $ctrl.$appConfig.resolveServiceUrl(
      "" + $ctrl.userSessions.url.replace(".json", ".csv")
    );
    return (location.href = url);
  }
  $onInit() {
    let $ctrl = this;
    /*
			setTimeout(function () {
			  window.scrollTo(0, 0);
			}, 3000);
		*/
  }
  reloadUserSessions() {
    let $ctrl = this;
    $ctrl.userSessions.criteria.startDate = moment(
      $ctrl.userSessionsStartDate
    ).format("YYYY/MM/DD");
    $ctrl.userSessions.criteria.endDate = moment(
      $ctrl.userSessionsEndDate
    ).format("YYYY/MM/DD");
    $ctrl.userSessions.load();
  }
  exportQuickReport(report) {
    const $ctrl = this;
    let url = $ctrl.$appConfig.resolveServiceUrl(
      "RunReport?reportName=QuickReport&displayName=" +
        report.name +
        " &output=xlsx&QuickReportID=" +
        report.id +
        "&QuickReportName=" +
        report.name
    );

    return (location.href = url);
  }
}

let b2bdashboard = {
  bindings: {
    repId: "@",
  },
  controller: B2BDashboardController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default b2bdashboard;
